import React, { useEffect, useState } from 'react';
import { mailingAPI } from '../../services/api';
import { useToast } from '../../context/ToastContext';

const CONSENT = '我們收集你的電話或電郵，用於會務通訊及直接促銷。你可以隨時取消訂閱。勾選即表示你已閱讀並同意上述用途。';

const MailingAdmin = () => {
  const { success, error } = useToast();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ display_name: '', phone_number: '', email: '', consent_given: false });

  const load = () => mailingAPI.adminList().then((response) => setRows(response.data || [])).catch(() => error('無法載入通訊錄'));

  useEffect(() => {
    load();
  }, []);

  const create = async (event) => {
    event.preventDefault();
    try {
      await mailingAPI.adminCreate(form);
      success('已加入通訊錄');
      setForm({ display_name: '', phone_number: '', email: '', consent_given: false });
      load();
    } catch (err) {
      const data = err.response?.data;
      error(data?.consent_given || data?.contact || '加入失敗');
    }
  };

  const exportCsv = async () => {
    try {
      const response = await mailingAPI.exportCsv();
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'mailing.csv';
      link.click();
      success('已匯出已同意且未取消的聯絡人');
    } catch (err) {
      error('匯出失敗');
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>通訊錄</h1>
        <button type="button" className="btn btn-primary" onClick={exportCsv}>匯出已同意名單</button>
      </div>
      <form className="pos-form-grid" onSubmit={create}>
        <label>稱呼
          <input value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} />
        </label>
        <label>電話
          <input value={form.phone_number} onChange={(e) => setForm({ ...form, phone_number: e.target.value })} />
        </label>
        <label>電郵
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </label>
        <label className="pos-check">
          <input type="checkbox" checked={form.consent_given} onChange={(e) => setForm({ ...form, consent_given: e.target.checked })} />
          同意
        </label>
        <p>{CONSENT}</p>
        <button type="submit" className="btn btn-primary">加入</button>
      </form>
      <table className="admin-table">
        <thead>
          <tr>
            <th>稱呼</th>
            <th>電話</th>
            <th>電郵</th>
            <th>狀態</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td>{row.display_name || '—'}</td>
              <td>{row.phone_number || '—'}</td>
              <td>{row.email || '—'}</td>
              <td>{row.is_unsubscribed ? '已取消訂閱' : '訂閱中'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MailingAdmin;
